<template>
  <div class="FilterBannerCarbonNeutral">
    <div class="FilterBannerCarbonNeutral__content">
      <p class="FilterBannerCarbonNeutral__title">
        <span>Always</span>
        <span class="FilterBannerCarbonNeutral__highlight">Carbon Neutral</span>
      </p>
      <VisionButton
        class="FilterBannerCarbonNeutral__btn"
        button-text="Learn More"
        background-colour="black"
        :outline="true"
        size="x-small"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script setup>
const { $track } = useNuxtApp()

const modalStore = useModalStore()

function openModal(slug) {
  modalStore.OPEN_MODAL_PAGE({ slug })
}

async function handleClick() {
  openModal('sustainability')

  await $track.global.linkClicked({
    interactionElement: 'carbon-neutral',
    interactionSection: 'Filter results',
    interactionCategory: 'Filter banner'
  }, 'Clicked Inline Filter Banner')
}
</script>

<style lang="postcss">
.FilterBannerCarbonNeutral {
  @apply bg-grey-light p-4 w-full flex flex-col items-start;

  @screen md {
    @apply p-10
  }
}

.FilterBannerCarbonNeutral__content {
  @apply mt-[20%];
}

.FilterBannerCarbonNeutral__title {
  @apply heading-3 font-bold text-off-black;

  @screen md {
    @apply heading-2;
  }
}

.FilterBannerCarbonNeutral__highlight {
  @apply text-base t-gradient block;

  @screen xs {
    @apply text-xl;
  }

  @screen md {
    @apply heading-1;
  }
}

.FilterBannerCarbonNeutral__btn {
  @apply mt-5;
}
</style>